import { usePhuture } from 'context/phuture-sdk'
import { BigNumber } from 'ethers'
import { useEffect, useState } from 'react'
import { Erc20 } from 'sdk'
import { useStore } from 'services/store'
import { Nullable } from 'utils/ts-utils'

export interface Erc20Response {
  erc20: Nullable<Erc20>
  symbol: string
  name: string
  decimals: number
  balance: BigNumber
  totalSupply: BigNumber
}

export const useERC20New = (address: string): Erc20Response => {
  const { account } = usePhuture()
  const { network } = useStore()
  const [symbol] = useState<string>('')
  const [name] = useState<string>('')
  const [decimals] = useState<number>(0)
  const [balance] = useState<BigNumber>(BigNumber.from(0))
  const [totalSupply] = useState<BigNumber>(BigNumber.from(0))

  if (!account) {
    return {
      erc20: null,
      symbol,
      name,
      decimals,
      balance,
      totalSupply,
    }
  }

  // const erc20 = useMemo(() => new Erc20(account, address), [account, address, network])

  useEffect(() => {
    // const getBalance = async () => {
    //   if (account) {
    //     const [symbol, name, decimals, balance, totalSupply] = await Promise.all([
    //       erc20.symbol(),
    //       erc20.name(),
    //       erc20.decimals(),
    //       erc20.contract.balanceOf(account.address()),
    //       erc20.contract.totalSupply(),
    //     ])
    //     setSymbol(symbol)
    //     setName(name)
    //     setDecimals(decimals)
    //     setBalance(balance)
    //     setTotalSupply(totalSupply)
    //   }
    // }
    // getBalance()
  }, [account, network, address])

  return {
    erc20: null,
    symbol,
    name,
    decimals,
    balance,
    totalSupply,
  }
}
